import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SubdirectoryArrowLeftIcon(props: IconProps) {
    return <Icon {...props} iconKey={"subdirectory_arrow_left"}/>
}
